import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Icon } from '@iconify/react';
import FaqData from './FaqData';

const FAQSection = () => {
  // FAQ data
  const faqs = [
    {
      id: 1,
      question: "What is Bildup AI?",
      answer: "Bildup AI is an AI-powered learning companion designed to support students, parents, and teachers. It helps learners master subjects at their own pace, while giving parents and educators real-time insights into progress and performance. Whether at home or in school, Bildup AI makes learning more engaging, personalized, and effective."
    },
    // {
    //   id: 2,
    //   question: "How does Bildup use AI in education?",
    //   answer: "Bildup uses artificial intelligence to understand each learner's strengths, weaknesses, and progress. It analyzes performance data to identify learning gaps and delivers targeted support - like explanations, practice questions, and feedback, tailored to the student's needs. Bildup AI also helps teachers and parents by providing actionable insights and lesson planning support."
    // },
    {
      id: 3,
      question: "Who can use Bildup AI?",
      answer: "Bildup AI is built for students in primary and secondary schools, along with their parents, teachers, and school administrators. Whether you're a parent looking to support your child at home, or a teacher seeking to better track student progress, Bildup AI adapts to your role and helps you make the most of every learning moment."
    },
    {
      id: 4,
      question: "How does Bildup AI personalize learning?",
      answer: "Bildup AI creates a unique learning path for each student based on their curriculum, performance, and learning style. As the student interacts with Bildup AI - asking questions, completing tasks, or reviewing lessons - the AI continuously adjusts the content and approach to ensure the learning experience stays relevant, challenging, and supportive."
    },
    {
      id: 5,
      question: "How to get started with Bildup AI?",
      answer: "Getting started is simple! Just request early access on our website to create a free account. Whether you're a student, parent, or educator, Bildup AI will guide you through setting up your profile and goals. From there, you'll get instant access to your personalized dashboard and can begin exploring all that Bildup AI has to offer."
    }
  ];



  return (
    <section className="py-16 px-4 bg-gray-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">FAQs</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Got questions? We've got answers! Explore our FAQs to learn more about how
            Bildup is revolutionizing education with AI-powered learning. If you need
            further assistance, feel free to reach out!
          </p>
        </div>

        <FaqData faqs={faqs} />
      </div>
    </section>
  );
};

export default FAQSection;
